import Instance from '../../../utils/Axios';

const EditarTipoAtraso = (ydata, id, show) => async (dispatch) => {
  await Instance()
    .put(`/tipoatrasos/${id}`, { ydata })
    .then(({ data }) => {
      dispatch({ type: 'PUT_TIPOATRASO', payload: data });
      show('success', 'Tipo de atraso editado com sucesso!');
    })
    .catch((err) => {
      // eslint-disable-next-line eqeqeq
      if (err.response.status != 200) {
        // show('warning', 'Preencha todos os campos');
      }
    });
};

export default EditarTipoAtraso;
